export default __webpack_public_path__ + "static/media/UserGuide_hr_HR.2e5c9326.pdf";